import React from 'react'
import PropTypes from 'prop-types'
import { numberToStrCurrency } from 'Shared/CurrencyLabel/CurrencyLabel'
import { Button } from 'loyal-react'

export default function TransferSummary ({
  selectedID,
  openModal,
  selectedDiscount,
  processing,
  pointsName
}) {
  const isError = selectedDiscount ? selectedDiscount.isError : true
  const valuePointsLabel = `${selectedDiscount !== null ? selectedDiscount.points : 0} ${pointsName}`
  const valueCreditosLabel = `R$ ${numberToStrCurrency(selectedDiscount !== null ? selectedDiscount.credit : 0, 2)}`

  return (
    <div className='transfer-summary-container p-0 col-md-4 col-12 border border-color-ui-3 radius bg-white mt-4'>
      <div className='border-bottom border-color-ui-2 px-2 py-3'>
        <h2>
          Resumo do Resgate
        </h2>
      </div>
      <div className='p-2 border-bottom border-color-ui-2 bg-ui-5'>
        <p aria-label='Tipo de resgate: Crédito em fatura'>
          Tipo de resgate: <strong className='txt-body-sm color-brand-4'>Crédito em fatura</strong>
        </p>
        <p aria-label={`Valor em pontos: ${valuePointsLabel}`}>
          Valor em pontos: <strong className='txt-body-sm color-brand-4'>{valuePointsLabel}</strong>
        </p>
        <p aria-label={`Valor em crédito: ${valueCreditosLabel}`}>
          Valor em crédito: <strong className='txt-body-sm color-brand-4'>{valueCreditosLabel}</strong>
        </p>
      </div>
      <div className='p-2'>
        <p>{process.env.REACT_APP_TEXT_SUMMARY_INVOICE_CREDIT || 'Ao clicar em transferir pontos, seus pontos serão convertidos em créditos, e estarão disponíveis na sua próxima fatura em aberto.'}</p>
        <Button
          id='finishRescueButton'
          className='mt-2 btn btn-featured btn-icon txt-button txt-font-body'
          onClick={openModal}
          disabled={isError}
          text={'Finalizar Resgate'}
          loading={processing}
        />
      </div>
    </div>
  )
}

TransferSummary.propTypes = {
  selectedID: PropTypes.string,
  openModal: PropTypes.func,
  selectedDiscount: PropTypes.object,
  processing: PropTypes.bool,
  pointsName: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/features/InvoiceCredit/TransferSummary.js